import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { Link } from 'react-router-dom'
import './header.css'
import '../../../node_modules/font-awesome/css/font-awesome.min.css'

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = { clicked: false };
    this.myFunction = this.myFunction.bind(this);
  }

  myFunction() {
    this.setState({ clicked: !this.state.clicked })
  }

  render() {
    const { clicked } = this.state;
    return (
      <div className={(clicked === true) ? "topnav responsive" : "topnav"} >
        <Link to="/">Inicio</Link>
        <Link to="galeria">Galería</Link>
        <Link to="mosaicos">Mosaicos</Link>
        <Link to="trayectoria">Nuestra Trayectoria</Link>
        <Link to="mosaicos">Mosaicos</Link>
        <Link to="rionegro">Rionegro</Link>
        <Link to="dosquebradas">Dosquebradas</Link>
        <Link to="" className="icon" onClick={this.myFunction}><i className="fa fa-bars"></i></Link>
      </div>
    )
  }
}
        //<Link to="/" className="logo"> <img alt="logo" src="./images/tiles/thumbs/1002.png"></img> </Link>


// WEBPACK FOOTER //
// ./src/components/header/Header.jsx